<template>
  <div class="box-1">
    <div class="text-center">
      <div class="img-info">
        <b style="text-left">Нийт хэмнэсэн дүн </b>
        <br />
        <span>
          <!-- <b style="text-right">{{ this.last2yearUsedBonus | pricewithindex }} ₮</b> -->
        </span>
        <b>
          <number
            ref="number2"
            :from="numberFrom"
            :format="theFormat"
            :to="this.last2yearUsedBonus"
            :duration="duration"
            :style="{ color: '#1660ab', fontSize: '16px' }"
            easing="Power4.easeOut"
          />
          {{ "₮" }}
        </b>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import numeral from "numeral";
import VueNumber from "vue-number-animation";
Vue.use(VueNumber);
export default {
  data() {
    return {
      last2yearUsedBonus: 0,
      numberFrom: 0,
      numberTo: 0,
      duration: 3,
    };
  },
  methods: {
    getNextAmount() {
      var tokenId = localStorage.getItem("authToken");
      var user = this.$auth.getMe();
      if (tokenId == null || user == null) {
        this.$auth.destroyToken();
        this.$auth.removeMe();
        this.$router.push({ name: "login" });
      }
      this.$bonusApi
        // this.$axiosApi
        .post(
          `bonus-card/info/token`,
          // `card/info`,
          { tokenId },
          {
            headers: {
              "Content-Type": "application/json",
              "Accept-Language": "mn",
            },
          }
        )
        .then((response) => {
          var results = response.data;
          if (results.status === 0) {
            this.last2yearUsedBonus = results.last2yearUsedBonus;
            this.endValue = results.last2yearUsedBonus;
          } else {
            this.balanceAmount = 0;
          }
        })
        .catch(() => {
          this.$auth.destroyToken();
          this.$auth.removeMe();
          this.$router.push({ name: "login" });
        });
    },
    theFormat(number) {
      return numeral(number).format(",");
    },
  },
  created() {
    this.getNextAmount();
  },
};
</script>
